import script from "./product-number-type-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./product-number-type-list.vue?vue&type=script&setup=true&lang=ts"

import "./product-number-type-list.vue?vue&type=style&index=0&id=6908e271&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6908e271"]])

export default __exports__